/**
 * Shared, delegated controls for the small research-reference dialogs.
 * Keeping behavior out of inline event attributes makes the controls easier to
 * audit and compatible with stricter script policies.
 */
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const opener = event.target.closest('[data-abl-dialog-open]');
  if (opener) {
    const dialogId = opener.getAttribute('data-abl-dialog-open');
    const dialog = dialogId ? document.getElementById(dialogId) : null;
    if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
    return;
  }

  const closeButton = event.target.closest('[data-abl-dialog-close]');
  if (closeButton) {
    const dialog = closeButton.closest('dialog');
    if (dialog && typeof dialog.close === 'function') dialog.close();
    return;
  }

  if (event.target.matches('dialog[data-abl-dialog]') && typeof event.target.close === 'function') {
    event.target.close();
  }
});
